'use es6';

export const BEFORE = 'BEFORE';
export const AFTER = 'AFTER';
export const AS_CHILD = 'AS_CHILD';